<template>
  <el-dialog
    title="更换网格图层"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :inline="true"
        label-position="top"
        :model="formInline"
        class="demo-form-inline"
        ref="form"
      >
        <el-form-item label="当前网格">
          <el-input
            v-model="pointInfo.pointName"
            disabled
            placeholder="当前网格"
          ></el-input>
        </el-form-item>
        <el-form-item label="图层文件" style="margin-right:0;width:100%;">
          <el-upload
            class="avatar-uploader"
            action="#"
            accept=".geojson"
            :http-request="uploadPicFileFun"
            :on-remove="handleRemove"
            :file-list="picFilesJson"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">请上传geojson文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { uploadFile } from "@/api/block.js";
import { changePointGenJson } from "@/api/point.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    pointInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      formInline: {
        partsType: ""
      },
      loading: false,
      picFilesJson: []
    };
  },
  mounted() {},
  methods: {
    uploadPicFileFun(file) {
      if (!file.file.name.endsWith(".geojson")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.geojson",
          type: "warning"
        });
        return;
      }
      this.uploadFileFun(file);
    },
    async uploadFileFun(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("objectName", "mapJson");
      formData.append("bussType", "mapJson");
      const res = await uploadFile(formData);
      if (res.data.code === 200) {
        this.picFilesJson[0] = {
          ...res.data.data,
          name: res.data.data.fileName,
          url:
            process.env.VUE_APP_API_DOMAIN +
            "/unified-code/file/download?filePath=" +
            res.data.data.filePath
        };
      }
    },
    handleRemove() {
      this.picFilesJson = [];
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async onSubmit() {
      if (this.picFilesJson.length == 0) {
        this.$message({
          message: "请上传文件",
          type: "warning"
        });
        return;
      }
      this.loading = true;
      let formData = new FormData();
      formData.append("pointId", this.pointInfo.id);
      formData.append("fileInfoId", this.picFilesJson[0].id);
      const res = await changePointGenJson(formData);

      this.loading = false;
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

.container-dialog {
  padding: 14px 24px 24px;
}
/deep/.el-form-item {
  width: calc(50% - 12px);
  margin-bottom: 20px;
  margin-right: 8px;
  .el-form-item__label {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #494c4f;
    line-height: 1;
  }
  .el-select {
    width: 100%;
  }
  .el-input__inner {
    height: 40px;
    width: 100%;
  }
}
/deep/.demo-drawer__footer {
  width: 100%;
  padding: 24px;
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  background: #fff;
}
/deep/.el-upload .el-upload__input {
  display: none;
}
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
  margin-top: 8px;
}
/deep/.el-upload--picture-card {
  line-height: 1;
  padding-top: 54px;
}
.list-pic {
  /deep/.el-upload--picture-card {
    display: none;
  }
  /deep/.el-upload-list--picture-card {
    img {
      width: 212px;
      height: 212px;
    }
  }
}
/deep/.container-dialog {
  padding-bottom: 112px;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/motherChildPoint/components/addDialog.vue